import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import { ApiManagersSkillEvaluationStandardSummaryCategoryEditType } from "~/domains";

type ParamsType = {
  id: string;
};

const request = async ({
  id,
}: ParamsType): Promise<ApiManagersSkillEvaluationStandardSummaryCategoryEditType> => {
  const response =
    await new ApiClient().get<ApiManagersSkillEvaluationStandardSummaryCategoryEditType>(
      `/api/managers/skill_evaluation_standard_summary_categories/${id}/edit`,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersSkillEvaluationStandardSummaryCategoriesEdit = ({
  id,
  config = {},
}: PropsType): UseQueryResult<ApiManagersSkillEvaluationStandardSummaryCategoryEditType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersSkillEvaluationStandardSummaryCategoriesEdit", id],
    cacheTime: 0,
    queryFn: () => request({ id }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
